/**
 * Help search — boundary contract schemas (help-center-chatbot DC-2, BR-13).
 *
 *   GET /landlord/api/help/search?q=   — ranked results with an excerpt
 */
import { z } from 'zod';
/** Max length of a help search query; the landlord search field enforces the same limit. */
export const HELP_SEARCH_QUERY_MAX_CHARS = 200;
export const SearchQuerySchema = z.object({
    q: z.string().max(HELP_SEARCH_QUERY_MAX_CHARS),
});
export const SearchResultSchema = z.object({
    articleId: z.string(),
    title: z.string(),
    excerpt: z.string(),
});
//# sourceMappingURL=search.js.map